import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ClassSelectorTableComp from './ClassSelectorTableComp';
import { TitleBar, barStyle } from './theme';

const ClassPickerComp = ({pageState, pickerState}) =>{

  const hideClassPicker = () =>{
    pickerState.setShowPicker(false);
  };

  return(
    <div style={{borderStyle: 'solid', borderWidth: '1px', borderColor: 'lightgrey', padding:'20px'}}>
      <TitleBar>
        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Select a Class</h3></Col>
        <Col xs='4'>
            <span className={'pull-right'}>
                <Button variant="danger" onClick={()=>hideClassPicker()}>Cancel</Button> &nbsp;
            </span>
        </Col>
      </TitleBar>
      <br/>
      <ClassSelectorTableComp pageState={pageState} pickerState={pickerState}/>

    </div>
  ); 
};

const ClassSelectorComp = ({pageState, bsBtnSize}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [classData, setClassData] = useState('');

  useEffect(()=>{
    let classFound = pageState.classes.find(e=> e.ClassID===pageState.classID);
    if(classFound)
      setClassData(classFound.Classname);
  });

  const showClassPicker = () =>{
    setShowPicker(true);
  };
  
  return (
    <div style={{paddingTop:'20px'}}>

        {!showPicker && 
        <Row>        
          <Col xs={2}><Button variant="primary" style={{float: 'right'}} onClick={()=>showClassPicker()}> Select Class </Button></Col>
          <Col xs={10} style={barStyle}> {classData} </Col>                                          
        </Row>
        }
        {showPicker && <ClassPickerComp pageState={pageState} pickerState = {{showPicker, setShowPicker}} />}
    </div>
  );
};

export default ClassSelectorComp;  